import { useGetFF as useFF } from '@fstack-tech/ff_react_module';

export const useGetFF = ({ flag_id, refresh_time }) => {
  const { isEnabled, value, loading, isError } = useFF({ flag_id, refresh_time });
  return { isEnabled, value, loading, isError };
};
